import React from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import getConfig from '../../../../../../../util/config';

const propTypes = {
  rosterQrCode: PropTypes.shape({
    id: PropTypes.string,
    sequence_number: PropTypes.number,
    roster_identity_link: PropTypes.shape({
      roster_identity: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string,
      }),
    }),
  }).isRequired,
  logoImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  flyerText: PropTypes.string,
};

const RosterQrCodesPrintItem = ({ rosterQrCode, logoImage, flyerText }) => {
  const { app } = getConfig();

  const rosterIdentity = rosterQrCode?.roster_identity_link?.roster_identity;

  return (
    <div className="roster-qr-codes-print-item">
      {!!rosterQrCode.sequence_number && (
        <span className="roster-qr-codes-print-item-sequence-number">
          QR #{rosterQrCode.sequence_number}
        </span>
      )}
      {!!logoImage?.url && (
        <div className="roster-qr-codes-print-item-logo">
          <img src={logoImage.url} alt="Logo" />
        </div>
      )}
      {!!flyerText && (
        <p className="roster-qr-codes-print-item-text">{flyerText}</p>
      )}
      <div className="roster-qr-codes-print-item-qr">
        <QRCode
          value={`${app?.baseUrl}/rqr/${rosterQrCode.id}`}
          renderAs="svg"
          size={160}
        />
      </div>
      <p className="roster-qr-codes-print-item-name">
        {[rosterIdentity?.first_name, rosterIdentity?.last_name]
          .filter(Boolean)
          .join(' ')}
      </p>
    </div>
  );
};

RosterQrCodesPrintItem.propTypes = propTypes;

export default RosterQrCodesPrintItem;
